<template>
  <div>
    <campaign />
  </div>
</template>

<script>
import campaign from "@/components/campaign.vue";
export default {
  name: "AudioMessage",
  components: { campaign }
};
</script>
